// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RatingCard-cls1__d6a06c57ca6c081185d9{/*!*/}.RatingCard-cls2___174c19f96303fac1db9{margin:0;color:#535366;color:var(--Neutral-90, #535366);font-family:Roboto;font-size:12px;font-style:normal;font-weight:400;line-height:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RatingCard-cls1__d6a06c57ca6c081185d9",
	"cls2": "RatingCard-cls2___174c19f96303fac1db9 RatingCard-cls1__d6a06c57ca6c081185d9"
};
export default ___CSS_LOADER_EXPORT___;
